// Single source of truth for the homepage customer testimonial video.
// Swap these values when the real customer video is uploaded.
// `isShort: true` switches the modal to a portrait 9:16 frame for YouTube Shorts.
export const homepageTestimonial = {
  videoId: 'd1zqawc6U8g',
  customerName: 'Verified OpenbooQ Customer',
  label: 'Real customer review',
  thumbnailUrl: 'https://i.ytimg.com/vi/d1zqawc6U8g/maxresdefault.jpg',
  isShort: true,
};
